import { render, staticRenderFns } from "./BackImageTitle.vue?vue&type=template&id=a6dd03a8&scoped=true&"
import script from "./BackImageTitle.vue?vue&type=script&lang=js&"
export * from "./BackImageTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6dd03a8",
  null
  
)

export default component.exports